import { Box, Button, Link, Typography } from "@mui/material";
import { Link as LinkRouterDom } from "react-router-dom";
import TopBar from "../../components/TopBar";
import HomeIcon from '@mui/icons-material/Home';
import { useDeleteDistrictByIdMutation, useGetDistrictQuery } from "../../api/districtApi";
import { useEffect, useState } from "react";
import { errorToast, successToast } from "../../utils/toastService";
import DataTable from "./DataTable";
import AddDistrictModal from "./AddDistrictModal";
import ViewDistrictModal from "./ViewDistrictModal";
import ConfirmationDialogBox from "../../components/ConfirmationDialogBox";
import EditDistrictModal from "./EditDistrictModal";
import routeUrls from "../../constants/routeUrls";

export default function DistrictList() {

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [search, setSearch] = useState('');
    const { data, isSuccess, isFetching, refetch } = useGetDistrictQuery({ page, pageSize, search }, { refetchOnMountOrArgChange: true });
    const [deleteDistrict] = useDeleteDistrictByIdMutation();

    const handlePageChange = (event, value) => {
        setPage(value);
    }

    const handleSearchValue = (value) => {
        setSearch(value);
    }


    const breadcrumbs = [
        <Link
            component={LinkRouterDom}
            underline="none"
            sx={{ display: 'flex', alignItems: 'center' }}
            color="rgb(103, 58, 183)"
            to={routeUrls.DASHBOARD}
        >
            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
        </Link>,
        <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }} color="rgb(105, 117, 134)">
            Survey Location
        </Typography>,
        <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }} color="rgb(105, 117, 134)">
            District List
        </Typography>
    ];

    const [openAddModal, setOpenAddModal] = useState(false);
    const [openViewModal, setOpenViewModal] = useState({
        id: 0,
        open: false
    });
    const [openDeleteModal, setOpenDeleteModal] = useState({
        id: 0,
        open: false
    });
    const [openEditModal, setOpenEditModal] = useState({
        id: 0,
        open: false,
    })

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
    }

    const handleCloseAddModal = () => {
        setOpenAddModal(false);
        refetch();
    }

    const handleOpenViewModal = ({ id }) => {
        setOpenViewModal({
            id: id,
            open: true
        });
    }

    const handleCloseViewModal = () => {
        setOpenViewModal({
            id: 0,
            open: false
        });
    }

    const handleOpenDeleteModal = ({ id }) => {
        console.log(id);
        setOpenDeleteModal({
            id: id,
            open: true
        })
    }

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal({
            id: 0,
            open: false
        })
    }

    const handleDeleteDistrict = () => {
        deleteDistrict({ id: openDeleteModal?.id }).then((response) => {
            if (response?.data?.success) {
                successToast('Deleted District Successfully');
                refetch();
            } else {
                errorToast('Unable To Delete District');
            }
        }).catch((error) => {
            errorToast('Unable To Delete District');
        })
        handleCloseDeleteModal();
    }

    const handleOpenEditModal = ({ id }) => {
        setOpenEditModal({
            id: id,
            open: true
        })
    }

    const handleCloseEditModal = () => {
        setOpenEditModal({
            id: 0,
            open: false
        })
        refetch();
    }

    useEffect(() => {
        refetch();
    }, [])

    return (
        <>
            <TopBar title={"District"} breadcrumbs={breadcrumbs} />

            {/* Table */}
            <Box mt={2}>
                <DataTable headers={[
                    '#',
                    'State Name',
                    'District Name',
                    'Actions'
                ]} action={
                    <Button variant="contained" onClick={handleOpenAddModal} sx={{ textTransform: 'none', fontWeight: 600 }}>Add District</Button>
                } data={data?.data} totalPages={data?.pagination?.totalPages} page={page} pageSize={pageSize} handlePageChange={handlePageChange}
                    handleSearchValue={handleSearchValue}
                    handleOpenEditModal={handleOpenEditModal} handleOpenDeleteModal={handleOpenDeleteModal} handleOpenViewModal={handleOpenViewModal} isSuccess={isSuccess && !isFetching} />
            </Box>

            <AddDistrictModal openModal={openAddModal} handleCloseModal={handleCloseAddModal} />

            {
                !!openViewModal?.id && (
                    <ViewDistrictModal id={openViewModal?.id} openModal={openViewModal?.open} handleCloseModal={handleCloseViewModal} />
                )
            }

            <ConfirmationDialogBox open={openDeleteModal.open} title={"Are you want to delete the district?"}
                onAccept={handleDeleteDistrict}
                onReject={handleCloseDeleteModal}
            />

            {
                !!openEditModal?.id && (
                    <EditDistrictModal id={openEditModal?.id} openModal={openEditModal?.open} handleCloseModal={handleCloseEditModal} />
                )
            }
        </>
    )
}